import { ControlSettingsAdjust } from '@fs/zion-icon/dist/cjs/icons'
import { Checkbox, QuickGlanceOverlay, Row, Select, useOverlay, Button } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcDatePicker } from '../../../common/DmcDatePicker/DmcDatePicker'

export default function FamousSearchFiltersButton({
  useBirthYearRange,
  startBirthYearItem,
  endBirthYearItem,
  useDeathYearRange,
  startDeathYearItem,
  endDeathYearItem,
  country,
  countries,
  onFilterOrFieldChange,
}) {
  const { t } = useTranslation()
  const overlay = useOverlay()

  return (
    <>
      <Button Icon={ControlSettingsAdjust} onClick={overlay.handleClick}>
        {t('filters.filterBy', 'Filter By')}
      </Button>
      <QuickGlanceOverlay {...overlay} title={t('filters.advancedFilter', 'Advanced Filter')}>
        <>
          <Row>
            <DmcDatePicker
              label={
                useBirthYearRange
                  ? t('tools.lists.labels.startBirthYear', 'Start Birth Year')
                  : t('tools.lists.labels.birthYear', 'Birth Year')
              }
              selectedItem={startBirthYearItem}
              setSelectedItem={(e) => onFilterOrFieldChange('startBirthYearItem', e)}
              dayMonthYearDateFormat="yyyy"
              monthYearDateFormat="yyyy"
              yearDateFormat="yyyy"
            />
            {useBirthYearRange && (
              <DmcDatePicker
                label={t('tools.lists.labels.endBirthYear', 'End Birth Year')}
                selectedItem={endBirthYearItem}
                setSelectedItem={(e) => onFilterOrFieldChange('endBirthYearItem', e)}
                dayMonthYearDateFormat="yyyy"
                monthYearDateFormat="yyyy"
                yearDateFormat="yyyy"
              />
            )}
            <Checkbox
              name="birthDateRangeCheckbox"
              label={t('tools.lists.labels.dateRange', 'Date Range')}
              checked={useBirthYearRange}
              onChange={(event) => onFilterOrFieldChange('shouldUseBirthYearRange', event.target.checked)}
              alignY="nextToInput"
            />
          </Row>
          <Row>
            <DmcDatePicker
              label={
                useDeathYearRange
                  ? t('tools.lists.labels.startDeathYear', 'Start Death Year')
                  : t('tools.lists.labels.deathYear', 'Death Year')
              }
              selectedItem={startDeathYearItem}
              setSelectedItem={(e) => onFilterOrFieldChange('startDeathYearItem', e)}
              dayMonthYearDateFormat="yyyy"
              monthYearDateFormat="yyyy"
              yearDateFormat="yyyy"
            />
            {useDeathYearRange && (
              <DmcDatePicker
                label={t('tools.lists.labels.endDeathYear', 'End Death Year')}
                selectedItem={endDeathYearItem}
                setSelectedItem={(e) => onFilterOrFieldChange('endDeathYearItem', e)}
                dayMonthYearDateFormat="yyyy"
                monthYearDateFormat="yyyy"
                yearDateFormat="yyyy"
              />
            )}
            <Checkbox
              name="deathDateRangeCheckbox"
              label={t('tools.lists.labels.dateRange', 'Date Range')}
              checked={useDeathYearRange}
              onChange={(event) => onFilterOrFieldChange('shouldUseDeathYearRange', event.target.checked)}
              alignY="nextToInput"
            />
          </Row>
          <Row>
            <Select
              id="country"
              placeholder={t('tools.lists.placeholders.selectMultiAreaTeam', 'Select Multi-area Team')}
              label={t('tools.lists.labels.multiAreaTeam', 'Multi-area Team')}
              value={country}
              onChange={(e) => onFilterOrFieldChange('country', e.target.value)}
              options={countries}
            />
          </Row>
        </>
      </QuickGlanceOverlay>
    </>
  )
}
